import Vue from 'vue'
import Vuex from 'vuex'
import getters from "./app/getters";
import mutations from "./app/mutations";

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    filterSection: false,
    backdrop: false,
    fileToDownload: '',
    windowWidth: 0,
  },
  getters,
  mutations,
  actions: {
  },
  modules: {
  }
})
